import { homePageStyles } from "@insite/content-library/Pages/HomePage"; 

homePageStyles.page = {
    fullWidth: [true, true, true, true, true],
}